export interface SyncAction<T = any> {
  type: string;
  payload?: T;
}

export interface FetchSyncPayload {
  connections: string[];
  syncType?: string;
  dataType?: string;
}

export interface SyncActionPayload {
  fullSync?: boolean;
  dataType?: string;
  connectionUuid: string;
}

export const SYNC_STORE_NAME = 'sync';

export const SYNC_INITIAL_STATE: SyncState = {
  syncs: [
    {
      status: 'inProgress',
      requestId: '',
      connectionUuid: '',
    },
  ],
  loading: false,
  error: null,
};

export interface SyncState {
  syncs: SyncResponse[];
  loading?: boolean;
  error?: any;
}
export interface SyncResponse {
  requestId?: string;
  status: string;
  connectionUuid: string;
  dataType?: string;
}
